<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <div class="formControl mt">
      <pr-input-radio
        formControlName="gestionFinanciere"
        direction="column"
        [isDefault]="false"
        [options]="options"
        columns="1"
        [derrors]="derrors"
      >
      </pr-input-radio>
    </div>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
